export default "__VITE_ASSET__DcAK6Rlj__"